<template>
    <div class="growthfootprintassemblyindex" :style="`height: ${maxH+50}px;`">       
       <div class="box" :key="index" v-for="(item,index) in dataList" @click="growthfootprintassemblyadd(item.assemblyCode)">
           <div class="top">{{item.assemblyName}}</div>
           <div class="img">
                 <img :src="item.firstLogo" v-if="item.firstLogo" alt="">
                 <img v-else src="https://cdnfile-10043692.file.myqcloud.com/admin/images/growthfootprint/quesheng.png" alt="">
                 <div class="num">
                    <el-tag size="medium">数量：{{item.assemblyCount}}</el-tag>
                 </div>
           </div>
       </div>
    </div>
</template>
<script>
    import windowResize from "@/mixins/windowResize";
    import {getGrowthBookAssemblyList} from '@/api/growthfootprint';
    export default {
        data() {
            return {
                dataList: [] 
            }
        },
        mixins: [windowResize],       
        created() {
            this.getGrowthBookAssemblyList()
        },
        methods: {          
            //获取列表
            getGrowthBookAssemblyList() {
                getGrowthBookAssemblyList()
                    .then(res => res.data)
                    .then(data => {
                        this.dataList = data.data;
                    })
            },
            growthfootprintassemblyadd(assemblyCode) {
                if(assemblyCode=="1001"){
                  this.$router.push({path: 'growthfootprintassemblyadd', query: {assemblyCode: assemblyCode}});
                }else{
                    if(assemblyCode=="1004"){
                       this.$router.push({path: 'growthfootprintassemblyaddthree', query: {assemblyCode: assemblyCode}});
                    }else{
                        this.$router.push({path: 'growthfootprintassemblyaddtwo', query: {assemblyCode: assemblyCode}});
                    }
                }
                
            },
        },
    }
</script>

<style lang="scss" scoped>
   .growthfootprintassemblyindex{
       padding: 15px;
       overflow: auto;
       .box{
           float: left;
           width: 250px;
           margin: 0 10px 10px 0;
           border-radius: 5px;
           border:1px solid #e7eaec;
           .top{
               line-height: 36px;
               color:#303133;
               font-size: 16px;
               text-align: center;
               border-bottom:1px solid #e7eaec;
           }
           .img{
               padding: 5px;
               cursor:pointer;
               img{
                   width: 100%;
                   height: 340px;
                   display: block;
               }
               .num{
                   margin-top: 5px;
               }
           }
       }
       
   }
</style>



// WEBPACK FOOTER //
// src/views/growthfootprint/growthfootprintassemblyindex.vue